<template>
  <FlexColumn :space="4">
    <Label text="リストで候補者を整理します" size="body-2" style="color: #aaa" class="mb-3 mt-n1" />
    
    <Label text="デフォルトのリスト" class="mb-1" bold />
    <FlexColumn>
      <TextLink primary :to="`${$route.path}?signal=true`" >
        <FlexRow align="center">
          <Label text="Hotリスト" style="margin-bottom: -2px"/>
          <HotListInformationIcon  style="margin-left: -10px" />
        </FlexRow>
      </TextLink>
      <TextLink primary :to="`${$route.path}?requested=true`">
        スカウト済一覧
      </TextLink>
      <TextLink primary :to="`${$route.path}?list=favorite`">
        お気に入り一覧
      </TextLink>
      <TextLink primary :to="`${$route.path}?list=hidden`">
        非表示一覧
      </TextLink>
    </FlexColumn>

    <FlexColumn :space="0">
      <FlexRow align="baseline" justify="space-between">
        <Label text="作成したリスト" class="mb-1" bold />
        <Label text="リストを作成" color="primary" clickable @click="createDialog = true" />
      </FlexRow>
      
      <FlexRow :space="0" wrap style="gap: 8px 3px">
        <Tooltip
            v-for="list in lists"
            :key="list.id"
            :message="list.name"
            open-delay="700"
        >
          <Chip
              size="small"
              outlined link close rectangle
              color="#555"
              @click="handleSelectList(list)"
              @close="deleteList = list"
          >
            {{ truncate(list.name, 22) }}
            <v-icon
                style="font-size: 15px; margin-right: -6px; margin-left: 14px"
                @click.stop="editList = list"
            >
              mdi-pencil
            </v-icon>
          </Chip>
        </Tooltip>
      </FlexRow>
    </FlexColumn>
    
    <ApplicantListSaveDialog :open="createDialog" @close="createDialog = false" />
    <ApplicantListDeleteDialog :open="deleteList !== undefined" :list="deleteList" @close="deleteList = undefined" />
    <ApplicantListEditDialog :open="editList !== undefined" :list="editList" @close="editList = undefined" />
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import TextLink from "@/components/atoms/TextLink";
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import Chip from "@/components/atoms/Chip";
import ApplicantListSaveDialog from "@/components/organisms/ApplicantListSaveDialog";
import ApplicantListDeleteDialog from "@/components/organisms/ApplicantListDeleteDialog";
import Tooltip from "../atoms/Tooltip";
import ComponentMixin from "../ComponentMixin";
import ApplicantListEditDialog from './ApplicantListEditDialog'
import HotListInformationIcon from '../molecules/HotListInformationIcon.vue'

export default {
  mixins: [ComponentMixin],
  name: "ApplicantList",
  components: {
    HotListInformationIcon,
    ApplicantListEditDialog,
    Tooltip,
    ApplicantListDeleteDialog, ApplicantListSaveDialog, Chip, Label, FlexRow, TextLink, FlexColumn},
  data() {
    return {
      createDialog: false,
      editList: undefined,
      deleteList: undefined
    }
  },
  computed: {
    ...mapGetters('chatRequests', ['lists'])
  },
  methods: {
    handleSelectList(list) {
      this.$router.push({
        name: 'RequestsPage',
        params: {
          id: this.$route.params.id,
        },
        query: {
          list: list.id
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
